import styled from "styled-components"

const SpinnerCircle = styled.circle`
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
  stroke: currentColor;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
`

export const DeprecatedSpinner = styled.svg.attrs(() => ({
  as: "svg", // Impossible to display something else than an svg, it would not make any sense
  viewBox: "0 0 50 50",
  "aria-busy": true,
  children: <SpinnerCircle cx="25" cy="25" r="20" fill="none" strokeWidth="5"></SpinnerCircle>,
}))`
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  transform: rotate(0);
  animation: rotate 2s linear infinite;

  height: 1.5rem;
  width: 1.5rem;
`
